module.exports = __webpack_public_path__ + "d959daa90988a13472f5ec80f62bcbbc.pdf";